module.exports = __webpack_public_path__ + "img/cosmetics_1.61374c07.jpg";